import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

interface deleteLocationGroupInterface {
  id: string;
  name: string | unknown;
}

export const useDeleteLocationGroup = () => {
  return useMutation({
    mutationFn: deleteLocationGroup,
    onSuccess: (data, payload) => {
      if (payload) {
        queryClient.invalidateQueries(queryKeys.locationGroups.all());
        queryClient.invalidateQueries(queryKeys.viewLocations.all('all'));
        queryClient.invalidateQueries(
          queryKeys.getLocationGroupsWithLocationCount.pagination(),
        );
      }
    },
  });
};

const deleteLocationGroup = async (payload: deleteLocationGroupInterface) => {
  let locationGroupData = { name: payload.name };
  const response = await requestCCApi({
    url: `/locationGroups/${payload.id}`,
    method: 'DELETE',
    data: {
      data: locationGroupData,
    },
  });

  return response.data;
};
